import React, {Component} from 'react';
import Agreement from './Agreement';
import {Route} from 'react-router-dom';
import IdentificationPage from './IdentificationPage';
import JoinHistory from './JoinHistory';
import JoinCompletion from './JoinCompletion';
import Form from './Form';
import {PageContainer, PageTitle} from '../../Common/PageComponents';

import './Join.scss';

class Join extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="회원가입" data-qa="join" />
        <Route exact path="(/member-service/join|/member-service/join/agreement)" component={Agreement} />
        <Route exact path="/member-service/join/identification" component={IdentificationPage} />
        <Route exact path="/member-service/join/history" component={JoinHistory} />
        <Route exact path="/member-service/join/form" component={Form} />
        <Route exact path="/member-service/join/completion" component={JoinCompletion} />
      </PageContainer>
    );
  }
}

export default Join;
